// Step cascade orchestrator.
//
// Cross-checks (CA_01, EQ_01, AR_01, ...) come from the server with their
// execution-step list. As the reviewer answers prompts inside ExecutionSteps,
// downstream steps need to update immediately — without re-calling the server.
//
// The mapping from step.id → "what happens" lives in registry/ as plain data.
// The dispatcher walks that data. This file just wires them together.
//
// Adding a new cascade: edit one file under registry/. No change here.

import { CASCADE_REGISTRY } from "./registry";
import { dispatch } from "./dispatcher";

// resolveStepStatus handles a single cross-cutting rule: when a step is
// waiting on the agent for a depreciation AJE and the agent has already
// produced one (CA_01), mark the step completed.
export function resolveStepStatus(step, agentProposals) {
	if (step.mode === "agent_proposal" && step.status === "waiting_for_agent" && agentProposals && agentProposals.length > 0) {
		for (let p of agentProposals) {
			if (p.type === "aje" && p.triggered_by === "CA_01") {
				return {
					status: "completed",
					detail: "Depreciation AJE proposed ($" + Math.abs(p.amount).toLocaleString("en-CA") + ") — awaiting approval",
					substatus: "proposal_created",
				};
			}
		}
	}
	return step;
}

export function resolveStepsWithUserResponses(steps, userResponses, agentProposals, chartOfAccounts, crossCheckFacts) {
	if (!userResponses || Object.keys(userResponses).length === 0) {
		return steps.map(function (s) { return resolveStepStatus(s, agentProposals); });
	}

	let ctx = {
		steps: steps,
		userResponses: userResponses,
		agentProposals: agentProposals,
		chartOfAccounts: chartOfAccounts,
		crossCheckFacts: crossCheckFacts,
	};

	return steps.map(function (step) {
		let resolved = resolveStepStatus(step, agentProposals);
		let config = CASCADE_REGISTRY[resolved.id];
		return dispatch(resolved, ctx, config);
	});
}
